import axios from 'axios';
import store from 'src/store';

const HTTP  = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})


let isFetchingToken = false;
let tokenSubscribers = [];

function subscribeTokenRefresh(cb) {
  tokenSubscribers.push(cb);
}
function onTokenRefreshed(errRefreshing, token) {
  tokenSubscribers.map(cb => cb(errRefreshing, token));
}
function forceLogout() {
  store.dispatch('auth/destroyToken');
  window.location = '/login'
}


HTTP.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('access_token')

    if (token) {
      config.headers['Authorization'] = `Bearer ${ token }`
    }

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)


HTTP.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  if (error.response.status !== 401) {
    return new Promise((resolve, reject) => {
      reject(error);
    })
  }

  if (error.config.url == 'auth/refresh') {
    forceLogout();
    return new Promise((resolve, reject) => {
      reject(error);
    })
  }

  if (!isFetchingToken) {
    isFetchingToken = true;

    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return forceLogout();

    store.dispatch('auth/refreshToken')
      .then(() => {
        isFetchingToken = false;
        const newAccessToken = localStorage.getItem('access_token');

        onTokenRefreshed(null, newAccessToken);
        tokenSubscribers = [];
      })
      .catch(err => {
        console.log(err)
        onTokenRefreshed(new Error('Unable to refresh access token'), null);
        tokenSubscribers = [];

        forceLogout();
      });
  }

  const initTokenSubscriber = new Promise((resolve, reject) => {
    subscribeTokenRefresh((errRefreshing) => {
      if (errRefreshing) return reject(errRefreshing);
      console.log(error.config)
      return resolve(HTTP(error.config));
    });
  });
  return initTokenSubscriber;

  // if (401 === error.response.status) {
  //     console.log("hey expired already!")
  //     store.dispatch('auth/destroyToken');
  //     window.location = '/login'
  // } else {
  //     return Promise.reject(error);
  // }
});

export default HTTP